import React from "react";
import logo from './logo.svg';
import './App.css';

function App() {

    const [appState, setAppState] = React.useState({
        caseFee: 0,
        discountOrInsurance: 0,
        minimumDownPayment: 0,
        contractTerm: 24, // Months
        downPayment: 0,
        monthlyPayment: 0
    });

    const onChange = (name) => (e) => {
        let copiedState = {...appState};
        copiedState[name] = parseFloat(e.target.value);

        if (copiedState.downPayment < copiedState.minimumDownPayment) {
            copiedState.downPayment = copiedState.minimumDownPayment;
        }

        let remainingValue = copiedState.caseFee - copiedState.discountOrInsurance;

        if (["caseFee", "discountOrInsurance", "minimumDownPayment"].indexOf(name) >= 0) {
            copiedState.monthlyPayment = (remainingValue - copiedState.minimumDownPayment) / copiedState.contractTerm;
        }

        if (name === "monthlyPayment") {
            // Calculate the down payment
            let totalPayments = copiedState.monthlyPayment * copiedState.contractTerm;
            let tmpDownPayment = remainingValue - totalPayments;
            if (tmpDownPayment < copiedState.minimumDownPayment) {
                tmpDownPayment = copiedState.minimumDownPayment;
            }

            copiedState.downPayment = tmpDownPayment;
        }

        remainingValue -= copiedState.downPayment;

        if (name === "contractTerm" || name === "downPayment") {
            // Calculate the monthly payment
            copiedState.monthlyPayment = remainingValue / copiedState.contractTerm;
        }

        setAppState(copiedState);
    }

    let leftOverFee = appState.caseFee - appState.discountOrInsurance;
    if (leftOverFee < 0) {
        leftOverFee = 0;
    }

    let minMonthly = 0,
        maxMonthly = (leftOverFee - appState.minimumDownPayment) / appState.contractTerm;


    return (
        <div className="App">
            <header className="App-header">
                <img src={logo} className="App-logo" alt="logo"/>
                <h6 className="mt-1 mb-0">Payment Calculator</h6>
            </header>
            <main className="container" id="main-content">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title text-center">Basics</h4>
                        <div className="row">
                            <div className="col-md-4 mb-1">
                                <label htmlFor="caseFee">Case Fee</label>
                                <input id="caseFee"
                                       type="number"
                                       className="form-control"
                                       value={appState.caseFee}
                                       onChange={onChange('caseFee')}/>
                            </div>
                            <div className="col-md-4 mb-1">
                                <label htmlFor="discountOrInsurance">Discount / Insurance</label>
                                <input id="discountOrInsurance"
                                       type="number"
                                       className="form-control"
                                       value={appState.discountOrInsurance}
                                       onChange={onChange('discountOrInsurance')}/>
                            </div>
                            <div className="col-md-4 mb-1">
                                <label htmlFor="minimumDownPayment">Minimum Down Payment</label>
                                <input id="minimumDownPayment"
                                       type="number"
                                       className="form-control"
                                       value={appState.minimumDownPayment}
                                       onChange={onChange('minimumDownPayment')}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-1" id="sliders-container">
                    <div className="card-body">
                        <h4 className="card-title text-center">Customize</h4>
                        <div className="mb-1">
                            <label>Contract Term (months)</label>
                            <input type="range"
                                   className="form-range"
                                   min={6}
                                   max={30}
                                   value={appState.contractTerm}
                                   onChange={onChange('contractTerm')}/>
                        </div>
                        <div className="mb-1">
                            <label>Down Payment</label>
                            <input type="range"
                                   className="form-range"
                                   min={appState.minimumDownPayment}
                                   max={leftOverFee}
                                   step={20}
                                   value={appState.downPayment}
                                   onChange={onChange('downPayment')}/>
                        </div>
                        <div className="mb-1">
                            <label>Monthly Payment</label>
                            <input type="range"
                                   className="form-range"
                                   min={minMonthly}
                                   max={maxMonthly}
                                   value={appState.monthlyPayment}
                                   onChange={onChange('monthlyPayment')}/>
                        </div>
                    </div>
                </div>
                <div className="card bg-primary text-white mt-3" id="finals-container">
                    <div className="d-flex flex-row justify-content-around p-1">
                        <div className="flex-1 text-center final-item">
                            <h5>Contract Term</h5>
                            <div className="icon-wrapper">
                                <i className="far fa-clock fa-4x"/>
                            </div>
                            <div className="affixed bg-primary">
                                {appState.contractTerm} months
                            </div>
                        </div>
                        <div className="flex-1 text-center final-item">
                            <h5>Down Payment</h5>
                            <div className="icon-wrapper">
                                <i className="fas fa-dollar-sign fa-4x"/>
                            </div>
                            <div className="affixed bg-primary">
                                ${appState.downPayment.toFixed(0)}
                            </div>
                        </div>
                        <div className="flex-1 text-center final-item">
                            <h5>Monthly Payment</h5>
                            <div className="icon-wrapper">
                                <i className="far fa-calendar-alt fa-4x"/>
                            </div>
                            <div className="affixed bg-primary">
                                ${appState.monthlyPayment.toFixed(2)}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <footer>
                <p className="text-muted">* This calculator is meant for informational and demonstration purposes only and does not imply a contractual agreement.</p>
            </footer>
        </div>
    );
}

export default App;
